import React from 'react'

const Loaders = () => {
  return (
    <div className="loading">Loading&#8230;</div>
  )
}

export default Loaders